module.exports = __webpack_public_path__ + "static/media/1.899ddf8c.jpg";